import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const magicBoxFn = /* @__PURE__ */ createRecipe('magic-box', {
  "rounded": "md",
  "elevation": "glass",
  "padded": true
}, [])

const magicBoxVariantMap = {
  "rounded": [
    "sm",
    "md",
    "lg",
    "xl"
  ],
  "elevation": [
    "none",
    "sm",
    "md",
    "lg",
    "glass"
  ],
  "padded": [
    "true",
    "false"
  ]
}

const magicBoxVariantKeys = Object.keys(magicBoxVariantMap)

export const magicBox = /* @__PURE__ */ Object.assign(memo(magicBoxFn.recipeFn), {
  __recipe__: true,
  __name__: 'magicBox',
  __getCompoundVariantCss__: magicBoxFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: magicBoxVariantKeys,
  variantMap: magicBoxVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, magicBoxVariantKeys)
  },
  getVariantProps: magicBoxFn.getVariantProps,
})